"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rfidTagDumpTruckTypes = void 0;
exports.rfidTagDumpTruckTypes = {
    SET_DATA_GRID: 'RFID TAG DUMP TRUCK TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'RFID TAG DUMP TRUCK TYPES ON PAGE CHANGE',
    ON_MUTATION_CLICK: 'RFID TAG DUMP TRUCK TYPES ON MUTATION',
    ON_CHANGE_DATAITEM: 'RFID TAG DUMP TRUCK TYPES ON CHANGE DATAITEM',
    ON_SAVE_DATAITEM: 'RFID TAG DUMP TRUCK TYPES ON SAVE DATAITEM',
    GET_DETAIL: 'RFID TAG DUMP TRUCK TYPES ON GET DETAIL',
    ON_FILTER_CHANGE: 'RFID TAG DUMP TRUCK TYPES ON FILTER CHANGE',
    ON_SORT_CHANGE: 'RFID TAG DUMP TRUCK TYPES ON SORT CHANGE',
    ON_DELETE: 'RFID TAG DUMP TRUCK TYPES ON DELETE',
    SET_ERROR: 'RFID TAG DUMP TRUCK TYPES REDUCER SET ERROR',
};
